import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export const RoleLevelMatrices = ({ structures, roles, isLoaded, emptyText, renderMatrix }) => {
  const groups = structures
    .map((structure) => ({
      structure,
      roles: roles.filter(
        ({ level_structure_id }) => level_structure_id === structure.level_structure_id
      ),
    }))
    .filter(({ roles }) => roles.length > 0);

  if (isLoaded && groups.length === 0) {
    return (
      <Stack flex={1} alignItems="center" justifyContent="center" gap={1} py={4}>
        <Typography variant="h5" fontWeight={700}>
          No roles yet
        </Typography>
        <Typography color="text.secondary">{emptyText}</Typography>
      </Stack>
    );
  }

  return (
    <Stack gap={3}>
      {groups.map((group) => (
        <Box
          key={group.structure.level_structure_id}
          component="section"
          aria-label={group.structure.name}
          border="1px solid"
          borderColor="border.main"
          borderRadius={2}
          boxShadow={25}
          bgcolor="background.paper"
          overflow="hidden"
        >
          <Stack
            direction="row"
            alignItems="baseline"
            gap={1.5}
            px={3}
            py={1.5}
            bgcolor="grey.50"
            borderBottom="1px solid"
            borderColor="border.main"
          >
            <Typography variant="h6" fontWeight={700} fontSize="1.125rem">
              {group.structure.name}
            </Typography>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              {`${group.roles.length} ${group.roles.length === 1 ? 'role' : 'roles'} · ${
                group.structure.levels.length
              } ${group.structure.levels.length === 1 ? 'level' : 'levels'}`}
            </Typography>
          </Stack>
          <Box py={1} overflow="auto">
            {renderMatrix(group)}
          </Box>
        </Box>
      ))}
    </Stack>
  );
};
